export default "__VITE_ASSET__DkUG2Xsj__"